import * as t from "io-ts";
import { ApiEvent } from "./ApiEvent";
import { UserEvent } from "./UserEvent";

export const EventProps = t.partial({
  domain: t.string,
  url: t.string,
  path: t.string,
  referrer: t.string,
  params: t.record(t.string, t.unknown),
  user_agent: t.string,
  request_user: UserEvent,
  element: t.string,
  element_id: t.string,
  element_path: t.string,
  api: ApiEvent,
  info: t.record(t.string, t.unknown),
});

export interface EventProps {
  domain?: string;
  url?: string;
  path?: string;
  referrer?: string;
  params?: Record<string, unknown>;
  user_agent?: string;
  request_user?: UserEvent;
  element?: string;
  element_id?: string;
  element_path?: string;
  api?: ApiEvent;
  info?: Record<string, unknown>;
}
